import { loginRequest } from '../authConfig';

export function handleLogin(instance) {
  instance.loginRedirect({ ...loginRequest, redirectUri: `${window.location.origin}/dashboard` }).catch((e) => {
    console.error(e);
  });
}

export function handleLogout(instance) {
  localStorage.clear();
  instance.logoutRedirect().catch((e) => {
    console.error(e);
  });
}
